<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="auth-card-title">{{ lang.title }}</div>
      <form class="auth-form" @submit.prevent="send()">
        <LabelInput
          @input="
            (value) => {
              data.email = value;
              emailError = '';
            }
          "
          :value="data.email"
          :errorText="emailError"
          :label="lang.emailLabel"
        />
        <LabelInput
          @input="
            (value) => {
              data.password = value;
              passwordError = '';
            }
          "
          type="password"
          :label="lang.passwordLabel"
        />
        <LabelInput
          @input="
            (value) => {
              data.referralCode = value;
            }
          "
          :label="lang.refrralLabel"
          :value="data.referralCode"
        />
        <div class="terms">
          <span
            class="checkbox"
            :class="{ 'checkbox-active': agree }"
            @click="agree = !agree"
          >
            <span class="checkmark" v-if="agree"></span>
          </span>
          <span class="auth-card-text">
            {{ lang.agreePhrase }}
            <a
              @click.prevent="$router.push('/Terms')"
              href="/Terms"
              class="auth-link"
              >{{ lang.termsLink }}</a
            >
          </span>
        </div>
        <button
          :class="{ disabled: disable }"
          :disabled="disable"
          type="submit"
          class="auth-confirm-btn"
        >
          {{ lang.confirmBtn }}
        </button>
      </form>
      <div class="auth-card-links">
        <div>
          <span class="auth-card-text">{{ lang.suggestPhrase }}</span
          >&nbsp;<a
            @click.prevent="$router.push('/Login')"
            href="/Login"
            class="auth-link"
            >{{ lang.suggestLink }}</a
          >
        </div>
      </div>
      <button class="auth-google-btn" @click="googleSso">
        <span>{{ lang.googleBtnLabel }}</span>
        <img src="../../assets/icons/google.svg" />
      </button>
    </div>
  </div>
</template>

<script>
const verifyType = {
  EMAIL: "Email",
  SMS: "SMS",
  GOOGLE_AUTHENTICATOR: "GoogleAuth",
};
export default {
  name: "Login",
  data() {
    return {
      lang: this.$languageDict().signup,
      recaptcha: false,
      agree: false,
      data: {
        authenticationType: "EMAIL",
        email: "",
        password: "",
        referralCode: "",
        deviceType: "",
        osType: "",
        browser: "",
      },
      emailError: "",
      passwordError: "",
    };
  },
  computed: {
    disable() {
      return (
        !this.data.email ||
        !this.data.password ||
        this.emailError.length > 0 ||
        this.passwordError.length > 0 ||
        !this.agree
      );
    },
    readOnly() {
      return localStorage.referralCode || this.$route.query.ref;
    },
  },
  methods: {
    googleSso() {
      window.location.href = this.$google_sso;
    },
    async send() {
      try {
        await this.checkEmail();
        await this.check2Pass();

        this.state.loading = true;
        const res = await this.$axios.post("/users/register", this.data);
        if (res.token) {
          this.$setToken(res.token, this.state.userInfo.remember);
          await this.$router.push("/Panel/Dashboard");
        } else {
          this.$cookies.set("username", this.data.email);
          this.state.userInfo.email = this.data.email;
          this.$error(res.message, "", "success");
          this.$router.push(
            "/TwoStep/" + verifyType[res.baseDTO.twoStepAuthenticationType]
          );
          // await this.$router.push("OTPConfirm");
        }
      } catch (e) {
        console.log(e);
      }
    },
    check2Pass() {
      if (
        !this.$validPass(this.data.password) ||
        this.data.password.length < 8
      ) {
        this.passwordError =
          this.state.lang === "fa"
            ? "رمز باید حداقل 8 کاراکتر باشد و شامل حرف بزرگ ، حرف کوچک و عدد باشد"
            : "password must be 8 character and contains an uppercase and a lowercase letter ";
        const title =
          this.state.lang === "fa"
            ? "اطلاعات وارد شده اشتباه است"
            : "wrong data";
        this.$error(title, this.passwordError);
        return Promise.reject("wrong pass : " + this.data.password);
      } else {
        this.passwordError = "";
      }
    },
    checkEmail() {
      if (!this.$validEmail(this.data.email) || !this.data.email) {
        this.emailError =
          this.state.lang === "fa"
            ? "ایمیل صحیح وارد نمایید"
            : "please Enter a valid Email";
        this.state.lang === "fa"
          ? this.$error("اطلاعات وارد شده اشتباه است", "ایمیل صحیح وارد نمایید")
          : this.$error("Wrong information", "please Enter a valid Email");
        return Promise.reject("repeat failed: " + this.data.email);
      } else {
        this.emailError = "";
      }
    },

    getData() {
      this.data.osType = this.$detectOs();
      this.data.browser = this.$detectBrowser() || "CHROME";
      this.data.deviceType = this.$detectDevice();
    },
  },
  mounted() {
    this.getData();
    if (this.$route.query.username) {
      this.data.email = this.$route.query.username;
    }
    if (this.$route.query.ref || localStorage.referralCode) {
      localStorage.referralCode =
        this.$route.query.ref || localStorage.referralCode;
      this.data.referralCode =
        this.$route.query.ref || localStorage.referralCode;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.terms {
  display: flex;
  align-items: center;
  column-gap: 4px;
}

.checkbox {
  cursor: pointer;
  background: #dbdbdb;
  border: 2px solid #828282;
  border-radius: 4px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox-active {
  background: linear-gradient(
    224.33deg,
    #6adbff 7.52%,
    #a781ee 46.64%,
    #ff00b8 102.53%
  );
  border: initial;
}

.checkmark {
  border: 2px solid #dbdbdb;
  background: linear-gradient(
    225deg,
    #18d5ff -14.29%,
    #6e12b6 52.07%,
    #ff00a8 112.52%
  );
  border-radius: 2px;
  width: 16px;
  height: 16px;
}
</style>
